export const wlDatas = {
  attributes: {
    campanha_default: "ElectyWebApp",
    empresa: "ELECTY",
    bg_color: null,
    cor_hover_botao_icon: "#99E8B4",
    usar_configuracao_padrao: true,
    steps_contratacao_pf: [
      {
        name: "Dados Pessoais",
        index: "1",
      },
      {
        name: "Endereço",
        index: "2",
      },
      {
        name: "Identificação",
        index: "3",
      },
      {
        name: "Conta de luz",
        index: "4",
      },
      {
        name: "Confirmação",
        index: "5",
      },
      {
        name: "Assinatura de Contrato",
        index: "6",
      },
    ],
    steps_contratacao_pj: [
      {
        name: "Dados da empresa",
        index: "1",
      },
      {
        name: "Identificação",
        index: "2",
      },
      {
        name: "Conta de luz",
        index: "3",
      },
      {
        name: "Confirmação",
        index: "4",
      },
      {
        name: "Assinatura de Contrato",
        index: "5",
      },
    ],
    steps_contratacao_ml: [
      {
        name: "Dados da empresa",
        index: "1",
      },
      {
        name: "Identificação",
        index: "2",
      },
      {
        name: "Assinatura de contrato",
        index: "3",
      },
    ],
    steps_dashboard_pf: [
      {
        name: "Usina selecionada",
        index: "1",
      },
      {
        name: "Contrato submetido para análise",
        index: "2",
      },
      {
        name: "Contrato assinado com a usina",
        index: "3",
      },
      {
        name: "Seu desconto chegou!",
        index: "4",
      },
    ],
    steps_dashboard_pj: [
      {
        name: "Usina selecionada",
        index: "1",
      },
      {
        name: "Contrato submetido para análise",
        index: "2",
      },
      {
        name: "Contrato assinado com a usina",
        index: "3",
      },
      {
        name: "Seu desconto chegou!",
        index: "4",
      },
    ],
    steps_dashboard_ml: [
      {
        name: "Contato comercial",
        index: "1",
      },
      {
        name: "Seleção de comercializadora ",
        index: "2",
      },
      {
        name: "Envio de documentos e assinatura de contrato",
        index: "3",
      },
      {
        name: "Assinatura de contrato com a comercializadora",
        index: "4",
      },
      {
        name: "Desconto ativo",
        index: "5",
      },
    ],
    config_campos_pipefy_data: {
      celular: "n_mero_de_telefone",
      // celular_txt: "telefone",
      campanha: "campanha",
      // campanha: "campanha_texto",
      municipio: "cidade",
      estado: "estado",
      valorConsumo: "valor_da_conta_de_luz",
      concessionaria: "concessionaria_texto",
      disponibilidade_atendimento: "disponibilidade_atendimento",
      tipo_conta: "tipo_do_cliente", //Qual a diferença de tipo_do_cliente para para_sua_casa_ou_para_seu_neg_cio
      xx: "para_sua_casa_ou_para_seu_neg_cio",
      assessor: "acessores",
      // xx: "cupom_de_desconto",         // Não esta comtemplado para a nova jornada
      json_form: "json", //??

      xxxx: "c_digo_validado", // código do sms ?
      nome_contrato: "nome", // Tem nome / sobrenome e nome_contrato /contratar/desconto-usinas/formulario-novajornada
      email: "email",
      taxvat_contrato: "cpf", //cpf e cnpj é o mesmo campo taxvat_contrato não existe distinção
      taxvat_contrato: "cnpj",
      xxxx: "sele_o_de_lista", //??
      profissao: "profiss_o",
      cep_contrato: "cep",
      endereco_contrato: "rua",
      numero_endereco_contrato: "n_mero",
      complemento_endereco_contrato: "complemento",
      // xxxx: "completou_o_fluxo_webapp",    // Na tela dados-form-enviados e na tela confirme-dados-form não consta envio desta confirmação
      json_fase_3: "json_1", //??
      logou_na_plataforma: "clicou_cta_entrar",
      // x: "clicou_cta_esqueceu_senha",              // Procurei na /usuario/entrar e usuario/password-reset e não tem envio de dados
      // x: "nova_senha_inserida_clicoucta_atualizar",
    },
    // config_campos_pipefy_data: {
    //   nome: 'nome',
    //   sobrenome: 'sobrenome',
    //   email: 'email',
    //   celular: 'n_mero_de_telefone',
    //   municipio: 'cidade',
    //   estado: 'estado',
    //   estado_combo: 'estados_combobox',
    //   tipo_conta: 'para_sua_casa_ou_para_seu_neg_cio_2',
    //   valor_medio_mensal_da_conta: 'valor_m_dio_mensal_na_conta_de_luz',
    //   representante: 'campanha',// Campanha que o lead foi capturado
    //   assessor: 'acessores',// Responsável pelo lead na campanha - opcional
    //   clique_ver_ofertas_disponiveis: 'clique_cta_ver_ofertas_dispon_veis',
    //   economia_estimada: 'economia_estimada',
    //   concessionaria_pipe: 'concessionaria',// ID DA CONCESSIONARIA NO PIPEFY
    //   usina_ofertada_pipe: 'geradora_escolhida',// ID DO GERADOR NO PIPEFY
    //   clique_cta_usina_listing_pipe: 'geradora_listing',// ID DO GERADOR NO PIPEFY
    //   clique_cta1_card_usina_pipe: 'clicou_cta_1_geradora',// ID DO GERADOR NO PIPEFY
    //   clique_cta2_card_usina_pipe: 'clicou_cta_2_geradora',// ID DO GERADOR NO PIPEFY

    //   disponibilidade_atendimento: 'disponibilidade_atendimento',// Sim, Não
    //   nome_concessionaria: 'concessionaria_new',// RECEBE O NOME DA CONCESSIONARIA SELECIONADA
    //   nome_usina_ofertada: 'lista_1',// RECEBE O NOME DA USINA SELECIONADA
    //   nome_concessionaria_txt: 'concessionaria_txt_1',// RECEBE O NOME DA CONCESSIONARIA SELECIONADA PARA BKP
    //   nome_usina_ofertada_txt: 'geradora_txt_1',// RECEBE O NOME DA USINA SELECIONADA PARA BKP
    //   clique_cta_usina_listing_nome: 'geradora_listing_new',// RECEBE O LIST COM NOME DA USINA SELECIONADA
    //   clique_cta1_card_usina_listing_nome: 'clique_cta1_card_geradora_new',// RECEBE O LIST COM NOME DA USINA SELECIONADA
    //   clique_cta2_card_usina_listing_nome: 'copy_of_clique_cta1_card_geradora_new',// RECEBE O LIST COM NOME DA USINA SELECIONADA

    //   clique_cta_solicitar_ml: 'fale_com_nosso_time',
    //   mercado_livre: 'cliente_mercado_livre',
    //   nome_contrato: 'nome_contrato',
    //   cnpj: 'cnpj',
    //   cpf: 'cpf',
    //   cep: 'cep',
    //   endereco_rua: 'rua',
    //   complemento: 'complemento',
    //   numero: 'n_mero',
    //   completou_fluxo: 'completou_o_fluxo',
    //   engajamento_com_proposta_de_valor: 'engajamento_com_proposta_de_valor',
    //   logou_na_plataforma: 'clicou_cta_entrar',
    //   clique_cta_continuar1_ml: 'clicou_cta_1_de_ml_continuar',
    //   clique_cta_continuar2_ml: 'clicou_cta_2_de_ml_continuar',
    //   conta_de_luz_enviada: 'conta_de_luz_enviada',
    //   codigo_validado: 'c_digo_validado',
    //   confirmacao_dados: 'confirma_o_de_dados',
    //   origem_api: 'origem_api',
    // },
    config_campos_pipefy_step: {},
    config_campos_sharpspring: {
      cep: "cep_632722cc60e5b",
      cpf: "cpf_63272c763e68f",
      kwh: "kwh_636463b37e3e5",
      city: "city",
      cnpj: "cnpj_638f40958ef62",
      nome_contrato: "nome_do_contratante_637672c65a776",
      email: "emailAddress",
      state: "state",
      title: "title",
      active: "active",
      estado: "estado_br_63272aa7507fd",
      numero: "n__mero_636af156a0648",
      status: "status",
      street: "street",
      celular: "phoneNumber",
      country: "country",
      ownerID: "ownerID",
      persona: "persona",
      website: "website",
      zipcode: "zipcode",
      industry: "industry",
      pessoa_f: "pessoa_f__sica_632721dc6a4e4",
      accountID: "accountID",
      faxNumber: "faxNumber",
      firstName: "firstName",
      isContact: "isContact",
      leadScore: "leadScore",
      municipio: "munic__pio_632723186b971",
      campaignID: "campaignID",
      isCustomer: "isCustomer",
      leadStatus: "leadStatus",
      pessoa_jur: "pessoa_jur__dica__632722135ac4d",
      trackingID: "trackingID",
      companyName: "companyName",
      complemento: "complemento_636af299c28af",
      description: "description",
      isQualified: "isQualified",
      emailAddress: "emailAddress",
      endereco_rua: "endere__o_rua_632722fb24df9",
      lista_espera: "est___na_lista_de_espera__636c140ab9171",
      mercado_livre: "mercado_livre_6480debf37b28",
      concessionaria: "concession__ria_63272b2dc7930", // RECEBE O SIGAGENTE DA CONCESSIONARIA
      isUnsubscribed: "isUnsubscribed",
      url_identidade: "documento_de_identidade__produto__64ca9e60f263c",
      usina_ofertada: "usina_ofertada_63272c5479152", // RECEBE O NOME_SHARPSPRING DA USINA OFERTADA
      completou_fluxo: "contrato_assinado__63272dd25a120",
      consumo_de_pico: "consumo_de_pico_63272b55ee53c",
      createTimestamp: "createTimestamp",
      periodo_de_pico: "per__odo_de_pico_633c271c6bc78",
      tipo_de_moradia: "tipo_de_moradia_633c27bce07ab",
      updateTimestamp: "updateTimestamp",
      url_conta_de_luz: "conta_de_luz__produto__64ca9e74bc7df",
      economia_estimada: "economia_estimada_63272b7386d0b",
      leadScoreWeighted: "leadScoreWeighted",
      mobilePhoneNumber: "mobilePhoneNumber",
      logou_na_plataforma: "clique_ver_ofertas_dispon__veis_647739e4342ab ",
      municipio_uf_espera: "munic__pio_uf_em_espera_636c14369ad87",
      onboarding_1_submit: "input_id",
      onboarding_2_submit: "input_id",
      onboarding_3_submit: "input_id",
      onboarding_4_submit: "input_id",
      onboarding_5_submit: "input_id",
      onboarding_6_submit: "input_id",
      unidade_consumidora: "unidade_consumidora_63647219059c7",
      url_contrato_social: "contrato_social__produto__64ca9e86a95c0",
      conta_de_luz_enviada: "conta_de_luz_enviada__63272d2beab87",
      ml_contrato_assinado: "ml_contrato_assinado_649322802595c",
      phoneNumberExtension: "phoneNumberExtension",
      clique_cta1_card_usina: "clique_cta_usina_listing__1__6477b9422e135", // RECEBE O LIST COM NOME_SHARPSPRING DA USINA SELECIONADA
      clique_cta2_card_usina: "clique_cta_usina_listing__1___1__6477b94bb741b", // RECEBE O LIST COM NOME_SHARPSPRING DA USINA SELECIONADA
      clique_cta_solicitar_ml: "clique_cta_solicitar_ml_6491fd92a31de",
      clique_cta_continuar1_ml: "clique_cta_continuar1_ml_6491fddf70b46",
      clique_cta_continuar2_ml: "clique_cta_continuar2_ml_6491fdff2563f",
      clique_cta_usina_listing: "cta_usina_listing_jacarepagua_64773c4d987ee", // RECEBE O LIST COM NOME_SHARPSPRING DA USINA SELECIONADA
      quantos_residentes_na_casa: "quantos_residentes_na_casa__633c28b16396e",
      clique_cta_ver_propostas_ml:
        "p__s_login_clique_cta_ver_propostas_64931ee291e99",
      disponibilidade_atendimento: "disponibilidade_atendimento__636ab4a0f0d91",
      valor_medio_mensal_da_conta: "valor_m__dio_mensal_da_conta_633c29221d7cc",
      clique_ver_ofertas_disponiveis:
        "clique_ver_ofertas_dispon__veis_647739e4342ab",
      engajamento_com_proposta_de_valor:
        "engajamento_com_proposta_de_valor__63245af1cb5cd",
    },
    bg_color_frame: null,
    cor_tema_primaria: "#26A150",
    cor_tema_secundaria: "#48BE70",
    cor_tema_3: "#ccf6d9",
    cor_tema_4: "#99E8B4",
    cor_tema_5: "#48BE70",
    cor_tema_botao_solido: "#26A150",
    cor_texto_botao: "#FFFFFF",
    cor_tema_botao_desabilitado: "#F2F5F2",
    cor_tema_botao_borda_desabilitado: "#B6B8B7",
    botao_gradiente: null,
    cor_botao_icone: "#26A150",
    cor_tema_botao_borda: "#26A150",
    cor_hover_botao_borda: "#99E8B4",
    cor_tema_step_default: "#26A150",
    cor_ponta_inferior_lateral_esquerda: "#68d08c",
    consentimento_cookie_text:
      "Armazenamos cookies para melhorar sua experiência de navegação. Conheca nossa [[Política de Privacidade]]",
    code_tag_manager: "MKJH6BG",
    logo_empresa: {
      data: {
        attributes: {
          url: "/wl/ELECTY/logo_empresa.png",
        },
      },
    },
    logo_empresa_2: {
      data: {
        attributes: {
          url: "/wl/ELECTY/logo_empresa_2.png",
        },
      },
    },
    logo_empresa_rodape: {
      data: null,
    },
    favicon: {
      data: {
        attributes: {
          url: "/wl/ELECTY/favicon.svg",
        },
      },
    },
    bg_img_frame: {
      data: {
        attributes: {
          url: "/wl/ELECTY/bg_img_frame.png",
        },
      },
    },
    splash: {
      data: {
        attributes: {
          url: "/wl/ELECTY/splash.gif",
        },
      },
    },
    card_esquerda: {
      data: {
        attributes: {
          url: "/wl/ELECTY/card_esquerda.png",
        },
      },
    },
    bg_img_redirect: {
      data: {
        attributes: {
          url: "/wl/ELECTY/bg_img_redirect.png",
        },
      },
    },
    icone_whatsapp: {
      data: {
        attributes: {
          url: "/wl/ELECTY/icone_whatsapp.png",
        },
      },
    },
    icone_duvidas: {
      data: {
        attributes: {
          url: "/wl/ELECTY/icone_duvidas.png",
        },
      },
    },
    bg_img_manutencao: {
      data: {
        attributes: {
          url: "/wl/ELECTY/bg_img_manutencao.png",
        },
      },
    },
    bg_img_error_aplicacao: {
      data: {
        attributes: {
          url: "/wl/ELECTY/bg_img_error_aplicacao.png",
        },
      },
    },
    Onboarding: {
      header_color: false,
      titulo_bem_vindo: "Bem vindo a Electy!",
      titulo_onboarding_1: "Por que a Electy?",
      descricao_onboarding_1:
        "Você vai conhecer um novo jeito de consumir energia: mais barata, mais sustentável, com mais liberdade de escolha e facilidade!",
      titulo_onboarding_2: "Energia na palma da sua mão",
      descricao_onboarding_2:
        "Escolha a usina parceira e o tipo de energia que irá consumir na sua casa.  Economize na conta de luz e tenha uma atitude sustentável.  ",
      titulo_onboarding_3: "Muito simples e seguro ",
      descricao_onboarding_3:
        "A contratação é simples e segura. E não se preocupe com falta de luz, pois você continuará ligado ao fornecimento tradicional de energia.",
      titulo_onboarding_4: "Escolha o melhor para você ",
      descricao_onboarding_4:
        "Informe o seu consumo. A gente apresenta as possibilidades. Você assina o contrato e nós avisamos à usina e a sua distribuidora.",
      titulo_onboarding_5: "Economia o ano inteiro ",
      descricao_onboarding_5:
        "No final do ciclo de consumo, você vai passar a pagar duas contas mas, o valor total será até 25% menor do que aquele que você paga hoje. ",
      titulo_onboarding_6: "Faça sua escolha",
      descricao_onboarding_6:
        "Chega de pagar caro por energia elétrica! Seja sustentável e economize. ",
      background_img: null,
      bg_img_onboarding_1: {
        data: {
          attributes: {
            url: "/wl/ELECTY/bg_img_onboarding_1.gif",
          },
        },
      },
      bg_img_onboarding_2: {
        data: {
          attributes: {
            url: "/wl/ELECTY/bg_img_onboarding_2.gif",
          },
        },
      },
      bg_img_onboarding_3: {
        data: {
          attributes: {
            url: "/wl/ELECTY/bg_img_onboarding_3.gif",
          },
        },
      },
      bg_img_onboarding_4: {
        data: {
          attributes: {
            url: "/wl/ELECTY/bg_img_onboarding_4.gif",
          },
        },
      },
      bg_img_onboarding_5: {
        data: {
          attributes: {
            url: "/wl/ELECTY/bg_img_onboarding_5.gif",
          },
        },
      },
      bg_img_onboarding_6: {
        data: {
          attributes: {
            url: "/wl/ELECTY/bg_img_onboarding_6.gif",
          },
        },
      },
    },
    Usuario: {
      bg_img_confirmacao_conta: {
        data: {
          attributes: {
            url: "/wl/ELECTY/bg_img_confirmacao_conta.svg",
          },
        },
      },
      bg_img_email_enviado: {
        data: {
          attributes: {
            url: "/wl/ELECTY/bg_img_email_enviado.svg",
          },
        },
      },
      bg_img_erro_link_invalido: {
        data: {
          attributes: {
            url: "/wl/ELECTY/bg_img_erro_link_invalido.svg",
          },
        },
      },
      bg_img_password_reset: {
        data: {
          attributes: {
            url: "/wl/ELECTY/bg_img_password_reset.svg",
          },
        },
      },
      bg_img_password_reset_success: {
        data: {
          attributes: {
            url: "/wl/ELECTY/bg_img_password_reset_success.svg",
          },
        },
      },
      bg_img_reenviar_email: {
        data: {
          attributes: {
            url: "/wl/ELECTY/bg_img_reenviar_email.svg",
          },
        },
      },
      bg_img_sem_conta: {
        data: {
          attributes: {
            url: "/wl/ELECTY/bg_img_sem_conta.png",
          },
        },
      },
    },
    Calculadora: {
      cor_botao_select: "#26A150",
      texto_descricao_consumo: null,
      cor_hover_botao_icon: "#99E8B4",
      habilitar_contrato_pf: true,
      habilitar_contrato_pj: true,
      habilitar_captura_fornecedor: false,
      texto_captura_fornecedor: null,
      bg_img_calculadora_success: {
        data: {
          attributes: {
            url: "/wl/ELECTY/bg_img_calculadora_success.png",
          },
        },
      },
      bg_img_calculadora_not_found: {
        data: {
          attributes: {
            url: "/wl/ELECTY/bg_img_calculadora_not_found.png",
          },
        },
      },
      titulo_sem_estoque:
        "Ah, que pena! A energia esgotou na sua região, devido a alta demanda.",
      descricao_sem_estoque:
        "Estamos trabalhando para ampliar a oferta de energia limpa e oferecê-la novamente em sua região. Não desanime! Enquanto isso, você está em nossa lista de espera e vamos te mantendo atualizado de todas as novidades da Electy.",
      img_sem_estoque: {
        data: {
          attributes: {
            url: "/wl/ELECTY/img_sem_estoque.png",
          },
        },
      },
      titulo_nao_atendida:
        "Ah, que pena! No momento, não temos energia disponível na sua região. ",
      descricao_nao_atendida:
        "Estamos trabalhando para, em breve, oferecer energia limpa e mais barata para você e todo Brasil. Não desanime! Enquanto isso, você está em nossa lista de espera e vamos te mantendo atualizado de todas as novidades da Electy.\nAgradecemos a sua compreensão e ficamos felizes pelo seu interesse em contribuir para um planeta mais sustentável!",
      img_nao_atendida: {
        data: {
          attributes: {
            url: "/wl/ELECTY/img_nao_atendida.png",
          },
        },
      },
      img_form_fornecedor: {
        data: null,
      },
      img_sem_consumo_minimo: {
        data: {
          attributes: {
            url: "/wl/ELECTY/img_sem_consumo_minimo.png",
          },
        },
      },
    },
    Coleta_Dados_Usuario: {
      bg_img_code_sms: {
        data: {
          attributes: {
            url: "/wl/ELECTY/bg_img_code_sms.png",
          },
        },
      },
      bg_img_confirmacao_dados_confirmacao_sms: {
        data: {
          attributes: {
            url: "/wl/ELECTY/bg_img_confirmacao_dados_confirmacao_sms.svg",
          },
        },
      },
      bg_img_localizacao: {
        data: {
          attributes: {
            url: "/wl/ELECTY/bg_img_localizacao.png",
          },
        },
      },
      bg_img_localizacao_nao_encontrado: {
        data: {
          attributes: {
            url: "/wl/ELECTY/bg_img_localizacao_nao_encontrado.png",
          },
        },
      },
    },
    Formulario: {
      bg_img_form: {
        data: {
          attributes: {
            url: "/wl/ELECTY/bg_img_form.png",
          },
        },
      },
      bg_img_form_confirmacao: {
        data: {
          attributes: {
            url: "/wl/ELECTY/bg_img_form_confirmacao.png",
          },
        },
      },
      bg_img_tooltip_form: {
        data: {
          attributes: {
            url: "/wl/ELECTY/bg_img_tooltip_form.png",
          },
        },
      },
    },
    Pessoa_Fisica: {
      Step_1: {
        bg_img_dados_nao_encontrados: {
          data: {
            attributes: {
              url: "/wl/ELECTY/bg_img_dados_nao_encontrados.png",
            },
          },
        },
        bg_img_dados_pessoais: {
          data: {
            attributes: {
              url: "/wl/ELECTY/bg_img_dados_pessoais.png",
            },
          },
        },
      },
      Step_2: {
        bg_img_confirme_dados_endereco: {
          data: {
            attributes: {
              url: "/wl/ELECTY/bg_img_confirme_dados_endereco.png",
            },
          },
        },
        bg_img_endereco: {
          data: {
            attributes: {
              url: "/wl/ELECTY/bg_img_endereco.png",
            },
          },
        },
      },
      Step_3: {
        bg_img_rg: {
          data: {
            attributes: {
              url: "/wl/ELECTY/bg_img_rg.png",
            },
          },
        },
        bg_img_tooltip_rg: {
          data: {
            attributes: {
              url: "/wl/ELECTY/bg_img_tooltip_rg.png",
            },
          },
        },
        bg_img_documento_adicionado: {
          data: {
            attributes: {
              url: "/wl/ELECTY/bg_img_documento_adicionado.svg",
            },
          },
        },
      },
      Step_4: {
        bg_img_conta_luz: {
          data: {
            attributes: {
              url: "/wl/ELECTY/bg_img_conta_luz.png",
            },
          },
        },
        bg_img_tooltip_conta_luz: {
          data: {
            attributes: {
              url: "/wl/ELECTY/bg_img_tooltip_conta_luz.png",
            },
          },
        },
        bg_img_conta_luz_adicionada: {
          data: {
            attributes: {
              url: "/wl/ELECTY/bg_img_conta_luz_adicionada.svg",
            },
          },
        },
      },
      Step_5: {
        bg_img_confirmacao_conta: {
          data: {
            attributes: {
              url: "/wl/ELECTY/bg_img_confirmacao_conta.png",
            },
          },
        },
      },
    },
    Pessoa_Juridica: {
      Step_1_pj: {
        bg_img_contrado_social_pj: {
          data: {
            attributes: {
              url: "/wl/ELECTY/bg_img_contrado_social_pj.png",
            },
          },
        },
        bg_img_tooltip_contrado_social_pj: {
          data: {
            attributes: {
              url: "/wl/ELECTY/bg_img_tooltip_contrado_social_pj.png",
            },
          },
        },
        bg_img_vamos_comecar_pj: {
          data: {
            attributes: {
              url: "/wl/ELECTY/bg_img_vamos_comecar_pj.png",
            },
          },
        },
        bg_img_dados_empresa_pj: {
          data: {
            attributes: {
              url: "/wl/ELECTY/bg_img_dados_empresa_pj.png",
            },
          },
        },
        bg_img_contrado_social_adicionado_pj: {
          data: {
            attributes: {
              url: "/wl/ELECTY/bg_img_contrado_social_adicionado_pj.svg",
            },
          },
        },
        bg_img_confirme_dados_empresa_pj: {
          data: {
            attributes: {
              url: "/wl/ELECTY/bg_img_confirme_dados_empresa_pj.png",
            },
          },
        },
        bg_img_possui_demanda_pj: {
          data: {
            attributes: {
              url: "/wl/ELECTY/bg_img_possui_demanda_pj.png",
            },
          },
        },
        bg_img_tooltip_possui_demanda_pj: {
          data: {
            attributes: {
              url: "/wl/ELECTY/bg_img_tooltip_possui_demanda_pj.png",
            },
          },
        },
      },
      Step_2_pj: {
        bg_img_rg_pj: {
          data: {
            attributes: {
              url: "/wl/ELECTY/bg_img_rg_pj.png",
            },
          },
        },
        bg_img_tooltip_rg_pj: {
          data: {
            attributes: {
              url: "/wl/ELECTY/bg_img_tooltip_rg_pj.png",
            },
          },
        },
      },
      Step_3_pj: {
        bg_img_conta_luz_pj: {
          data: {
            attributes: {
              url: "/wl/ELECTY/bg_img_conta_luz_pj.png",
            },
          },
        },
        bg_img_tooltip_conta_luz_pj: {
          data: {
            attributes: {
              url: "/wl/ELECTY/bg_img_tooltip_conta_luz_pj.png",
            },
          },
        },
        bg_img_conta_luz_adicionada_pj: {
          data: {
            attributes: {
              url: "/wl/ELECTY/bg_img_conta_luz_adicionada_pj.svg",
            },
          },
        },
      },
      Step_4_pj: {
        bg_img_dados_submetidos_pj: {
          data: {
            attributes: {
              url: "/wl/ELECTY/bg_img_dados_submetidos_pj.png",
            },
          },
        },
      },
    },
    Email: {
      bg_img_confirmacao_conta: {
        data: {
          attributes: {
            url: "/wl/ELECTY/bg_img_email_confirmacao_conta.svg",
          },
        },
      },
      bg_img_contrato_assinado: {
        data: {
          attributes: {
            url: "/wl/ELECTY/img_contrato_assinado.svg",
          },
        },
      },
    },
    Mercado_Livre: {
      bg_img_sucesso_solicitacao_contato: {
        data: {
          attributes: {
            url: "/wl/ELECTY/bg_img_sucesso_solicitacao_contato.svg",
          },
        },
      },
      bg_img_conta_luz_ml: {
        data: {
          attributes: {
            url: "/wl/ELECTY/bg_img_conta_luz_ml.png",
          },
        },
      },
      bg_img_tooltip_conta_luz_ml: {
        data: {
          attributes: {
            url: "/wl/ELECTY/bg_img_tooltip_conta_luz_ml.png",
          },
        },
      },
      bg_img_conta_luz_adicionada_ml: {
        data: {
          attributes: {
            url: "/wl/ELECTY/bg_img_conta_luz_adicionada_ml.svg",
          },
        },
      },
      entenda_porque_1: {
        data: {
          attributes: {
            url: "/wl/ELECTY/entenda_porque_1.gif",
          },
        },
      },
      bg_img_contrato_social_adicionado_ml: {
        data: {
          attributes: {
            url: "/wl/ELECTY/bg_img_contrato_social_adicionado_ml.svg",
          },
        },
      },
      bg_img_documento_adicionado_ml: {
        data: {
          attributes: {
            url: "/wl/ELECTY/bg_img_documento_adicionado_ml.svg",
          },
        },
      },
      bg_img_contrato_social_ml: {
        data: {
          attributes: {
            url: "/wl/ELECTY/bg_img_contrato_social_ml.png",
          },
        },
      },
      bg_img_tooltip_contrado_social: {
        data: {
          attributes: {
            url: "/wl/ELECTY/bg_img_tooltip_contrado_social.png",
          },
        },
      },
      bg_img_tooltip_documento_ml: {
        data: {
          attributes: {
            url: "/wl/ELECTY/bg_img_tooltip_documento_ml.png",
          },
        },
      },
      bg_img_documento_ml: {
        data: {
          attributes: {
            url: "/wl/ELECTY/bg_img_documento_ml.png",
          },
        },
      },
    },
    Zapsign: {
      bg_img_assinatura_contrato: {
        data: {
          attributes: {
            url: "/wl/ELECTY/bg_img_assinatura_contrato.png",
          },
        },
      },
      bg_img_contrato_assinado: {
        data: {
          attributes: {
            url: "/wl/ELECTY/bg_img_contrato_assinado.png",
          },
        },
      },
    },
  },
};
